import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import api from 'services';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import { MenuItem } from 'material-ui/Menu';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCountries } from 'actions/countries';

class PdaFilters extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            vesselName: '',
            vesselNames: [],
            ports: [],
        };
        
        this.vesselAutoComplete = _.debounce((searchText) => {
            if (searchText) {
                api.findVessel(searchText)
                    .then((response) => {
                        const vesselNames = response.data.data.map(vessel => ({
                            name: `${vessel.name} (${vessel.imoNumber})`,
                            item: vessel,
                        }));
    
                        this.setState({
                            vesselNames,
                        });
                    })
                    .catch(() => null);
            }
        }, 1000);

        this.portAutoComplete = _.debounce((searchText) => {
            if (searchText) {
                api.findPortAdmin({ name: searchText })
                    .then((response) => {
                        const ports = response.data.data.map(port => ({
                            name: `${port.name}`,
                            item: port,
                        }));
    
                        this.setState({
                            ports,
                        });
                    })
                    .catch(() => null);
            }
        }, 1000);
    }

    changeVesselName = (searchText) => {
        if (this.props.filter.vessel.name !== searchText) {
            this.props.modifyFilter('vessel', { _id: '', name: searchText }, () => {
                this.vesselAutoComplete(searchText);
            });
        }
    }

    chooseVessel = (selectedVessel) => {
        if (!selectedVessel) {
            return;
        }
        
        const { _id, name, imoNumber } = selectedVessel.item;
        this.props.modifyFilter('vessel', { _id, name: `${name} (${imoNumber})` });
    }

    changePortName = (searchText) => {
        if (this.props.filter.port.name !== searchText) {
            this.props.modifyFilter('port', { _id: '', name: searchText }, () => {
                this.portAutoComplete(searchText);
            });
        }
    }

    choosePort = (selectedPort) => {
        if (!selectedPort) {
            return;
        }

        const { _id, name } = selectedPort.item;
        this.props.modifyFilter('port', { _id, name });
    }

    handleSelectCountry = (e, i) => {
        e.preventDefault();
        if (i === 0) {
            this.props.modifyFilter('country', { name: '', _id: '' });
            return;
        }

        const { _id, name } = this.props.countries[i - 1];

        this.props.modifyFilter('country', { name, _id });
    }

    handleSelectVesselType = (e) => {
        e.preventDefault();
        this.props.modifyFilter('vesselType', e.target.innerText);
    }

    handleChangeDwt = (e, type) => {
        this.props.modifyFilter(type, parseInt(e.target.value));
    }

    handleCheckConfirmed = () => {
        this.props.modifyFilter('confirmed', !this.props.filter.confirmed);
    }

    render() {
        const {
            filter: { 
                vessel, vesselType, port, country, dwtMin, dwtMax, confirmed, 
            },
            handleFilter,
            countries,
            handleOpenAddDialog,
            vesselTypes,
            handleReset,
        } = this.props;
        const { vesselNames, ports } = this.state;
        
        return (
            <div style={{ marginLeft: '8px', marginRight: '8px' }}>
                <div className='row'>
                    <div>
                        <AutoComplete 
                            name='vesselName'
                            textFieldStyle={{ fontSize: '13px' }}
                            style={{ width: '180px' }}
                            floatingLabelText='Vessel Name'
                            hintText='Vessel Name'
                            searchText={vessel.name}
                            dataSource={vesselNames}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={this.changeVesselName}
                            onNewRequest={this.chooseVessel}
                            filter={AutoComplete.noFilter}
                            fullWidth
                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                            popoverProps={{
                                canAutoPosition: true,
                                style: {
                                    width: '300px',
                                },
                            }}
                        />
                    </div>
                    <div>
                        <SelectField 
                            style={{ width: '130px', marginLeft: '10px' }}
                            floatingLabelText='Vessel Type'
                            floatingLabelStyle={{ fontSize: '13px' }}
                            maxHeight={400}
                            value={vesselType}
                            name='Vessel Types'
                            onChange={this.handleSelectVesselType}
                        >
                            <MenuItem 
                                value=''
                                primaryText=''
                            />
                            {
                                vesselTypes.map(vesselType => (
                                    <MenuItem
                                        key={vesselType}
                                        value={vesselType}
                                        primaryText={vesselType}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div>
                        <SelectField 
                            style={{ width: '130px', marginLeft: '10px' }}
                            floatingLabelText='Country'
                            floatingLabelStyle={{ fontSize: '13px' }}
                            maxHeight={400}
                            value={country._id}
                            name='countries'
                            onChange={this.handleSelectCountry}
                            autoWidth
                        >
                            <MenuItem 
                                value=''
                                primaryText=''
                            />
                            {
                                countries && countries.map(country => (
                                    <MenuItem
                                        key={country._id}
                                        value={country._id}
                                        primaryText={country.name}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div>
                        <AutoComplete 
                            name='portName'
                            textFieldStyle={{ fontSize: '13px', marginLeft: '10px' }}
                            style={{ width: '130px' }}
                            floatingLabelText='Port Name'
                            hintText='Port name'
                            searchText={port.name}
                            dataSource={ports}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={this.changePortName}
                            onNewRequest={this.choosePort}
                            filter={AutoComplete.noFilter}
                            fullWidth
                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                            popoverProps={{
                                canAutoPosition: true,
                                style: {
                                    width: '300px',
                                },
                            }}
                        />
                    </div>
                    <div>
                        <TextField
                            style={{ width: '75px', marginLeft: '20px' }}
                            floatingLabelText='Min DWT'
                            floatingLabelStyle={{ fontSize: '13px' }}
                            type='number'
                            value={dwtMin || ''}
                            onChange={e => this.handleChangeDwt(e, 'dwtMin')}
                        />
                    </div>
                    <div>
                        <TextField
                            style={{ width: '75px', marginLeft: '10px' }}
                            floatingLabelText='Max DWT'
                            floatingLabelStyle={{ fontSize: '13px' }}
                            type='number'
                            value={dwtMax || ''}
                            onChange={e => this.handleChangeDwt(e, 'dwtMax')}
                        />
                    </div>
                    <div>
                        <Checkbox
                            label="Not Confirmed"
                            checked={!confirmed}
                            style={{ margin: '40px -25px 0 10px', width: '165px' }}
                            labelStyle={{ marginLeft: '-15px' }}
                            onCheck={this.handleCheckConfirmed}
                        />
                    </div>
                    <div>
                        <RaisedButton
                            style={{ margin: '27px 0 0 10px' }} 
                            primary
                            label='Search'
                            onClick={handleFilter}
                        />
                    </div>
                    <div>
                        <RaisedButton 
                            style={{ margin: '27px 0 0 10px' }}
                            secondary
                            label='Reset'
                            onClick={handleReset}
                        />
                    </div>
                    <div>
                        <RaisedButton 
                            style={{ margin: '27px 0 0 10px' }}
                            backgroundColor='#a4c639'
                            labelColor='#fff'
                            label='ADD'
                            onClick={handleOpenAddDialog}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

// export default PdaFilters;
export default connect(
    state => ({
        countries: state.countries.items,
    }),
    dispatch => bindActionCreators(
        {
            getCountries,
        },
        dispatch,
    ),
)(PdaFilters);



// WEBPACK FOOTER //
// ./app/components/Prices/Pda/PdaFilters.jsx